'use strict';
import {FormsListHeader} from '../forms/components/views/FormsListHeader';
// eslint-disable-next-line max-len
import {injector as ProjectViewAssetsContainerInjector} from './components/ProjectViewAssets/ProjectViewAssetsContainer';
import {AssetProjectViewActivity, ProjectViewActivity} from './components/ProjectViewActivity';
import {ProjectViewAssets} from './components/ProjectViewAssets';
import {ProjectViewManageAssetsHeader} from './components/ProjectViewManageAssetsHeader';
import {AssetProjectViewTasks, ProjectViewTasks} from './components/ProjectViewTasks';
import {ProjectViewTemplate} from './components/ProjectViewTemplate';
import {AssetProjectViewTimerLog, ProjectViewTimerLog} from './components/ProjectViewTimerLog';
import {StatusChart} from './components/StatusChart';
import {ProjectController} from './controllers/ProjectController';
import {ProjectsAssetProjectsListController} from './controllers/ProjectsAssetProjectsListController';
import {ProjectsManageAssetsController} from './controllers/ProjectsManageAssetsController';
import {RequirementStatusTableDirective} from './directives/RequirementStatusTableDirective';
import {TaskStatusTableDirective} from './directives/TaskStatusTableDirective';
import {AssetProjectDomainProvider} from './domain/AssetProjectDomain';
import {MilestoneDomainProvider} from './domain/MilestoneDomain';
import {ProjectDomainProvider} from './domain/ProjectDomain';
import {ProjectAssetsFilterService} from './filters/ProjectAssetsFilterService';
import {ProjectsAssetProjectsFilterMixin} from './filters/ProjectsAssetProjectsFilterMixin';
import {ProjectsManageAssetsFilterMixin} from './filters/ProjectsManageAssetsFilterMixin';
import {MilestonesCreateController, templates as MilestonesCreateTemplates} from './modals/MilestonesCreateController';
import {CacheTemplates as ProjectExportTemplates, ProjectExportController} from './modals/ProjectExportController';
import {CacheTemplates as ProjectImportTemplates, ProjectImportController} from './modals/ProjectImportController';
import {routerConfig} from './router';
import {routerAssetProjectProvider} from './router-asset-project';
import {routerProjectProvider} from './router-project';
import {routerProjectTemplateProvider} from './router-project-template';
import {ParentStatusService} from './services/ParentStatusService';
import {ProjectAssetMapClusterFactory} from './services/ProjectAssetMapClusterFactory';
import {ProjectImportExportService} from './services/ProjectImportExportService';
import {TaskStatusService} from './services/TaskStatusService';


const angular = require('angular');

module.exports = angular
  .module('app.projects', [])
  .config(routerConfig)
  .config(routerAssetProjectProvider)
  .config(routerProjectProvider)
  .config(routerProjectTemplateProvider)
  .run(ProjectViewAssetsContainerInjector)

  .value('AssetProjectViewActivity', AssetProjectViewActivity)
  .value('ProjectViewActivity', ProjectViewActivity)

  .value('ProjectViewAssets', ProjectViewAssets)

  .value('AssetProjectViewTasks', AssetProjectViewTasks)
  .value('ProjectViewTasks', ProjectViewTasks)

  .value('ProjectViewTemplate', ProjectViewTemplate)

  .value('AssetProjectViewTimerLog', AssetProjectViewTimerLog)
  .value('ProjectViewTimerLog', ProjectViewTimerLog)

  .value('StatusChartComponent', StatusChart)

  .provider('AssetProjectDomain', AssetProjectDomainProvider)
  .provider('MilestoneDomain', MilestoneDomainProvider)
  .provider('ProjectDomain', ProjectDomainProvider)

  .service(ParentStatusService.SERVICE_NAME, ParentStatusService)
  .factory('ProjectAssetMapClusterFactory', ProjectAssetMapClusterFactory)
  .service('ProjectImportExportService', ProjectImportExportService)
  .service('TaskStatusService', TaskStatusService)

  .service('ProjectAssetsFilterService', ProjectAssetsFilterService)
  .service('ProjectsAssetProjectsFilterMixin', ProjectsAssetProjectsFilterMixin)
  .service('ProjectsManageAssetsFilterMixin', ProjectsManageAssetsFilterMixin)

  .directive('requirementStatusTable', RequirementStatusTableDirective)
  .directive('taskStatusTable', TaskStatusTableDirective)

  /* View */
  .controller('ProjectController', ProjectController)
  .controller('ProjectsAssetProjectsListController', ProjectsAssetProjectsListController)
  .controller('ProjectsManageAssetsController', ProjectsManageAssetsController)
  .directive('projectViewManageAssetsHeader', ['reactDirective', reactDirective =>
    reactDirective(ProjectViewManageAssetsHeader),
  ])

  /* Modals */
  .controller('MilestonesCreateController', MilestonesCreateController)
  .run(MilestonesCreateTemplates)

  .controller('ProjectExportController', ProjectExportController)
  .run(ProjectExportTemplates)

  .controller('ProjectImportController', ProjectImportController)
  .run(ProjectImportTemplates)
;



// WEBPACK FOOTER //
// ./src/js/projects/index.js